import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

export default function NewsPanel() {
  const latest = [...newsList]
    .sort((a, b) => b.date.localeCompare(a.date))
    .slice(0, 6);

  return (
    <section className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-3 flex items-center justify-between border-b-2 border-background-200 pb-2.5">
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
          <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-500 text-primary-950">
            <i className="ri-newspaper-line text-sm" />
          </span>
          最新影视资讯
        </h2>
        <Link to="/news" className="flex items-center gap-1 text-sm text-foreground-500 transition-colors hover:text-primary-700">
          全部资讯
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <ul className="divide-y divide-background-200">
        {latest.map((item) => (
          <li key={item.id}>
            <Link to={`/news/${item.id}`} className="group flex items-start gap-3 py-3">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary-400 group-hover:bg-accent-500" />
              <div className="min-w-0 flex-1">
                <h3 className="line-clamp-1 text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-700 md:text-[15px]">
                  {item.title}
                </h3>
                <p className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                  <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-700">{item.category}</span>
                  <span>{item.date}</span>
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}